import React from 'react';

import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;

  & + & {
    margin-top: 8px;
  }

  img {
    position: absolute;
    right: 16px;
    top: 24px;
    transform: translateY(-50%);
    width: 24px;
    opacity: 0.3;
  }
`;

export const TextBox = styled.textarea<{ resizable?: boolean; scrollable?: boolean }>`
  width: 100%;
  height: 116px;
  overflow: ${(props) => (props.scrollable ? 'auto' : 'hidden')};
  display: flex;
  flex-flow: column nowrap;
  border-radius: 4px;
  color: var(--colorBlueGray1100);
  background-color: var(--colorBlueGray50);
  border: 1px solid rgb(213, 215, 216);
  padding: 16px;
  font-weight: 600;
  letter-spacing: 0.24px;
  line-height: 20px;
  font-size: 14px;
  outline: none;
  resize: ${(props) => (props.resizable ? 'vertical' : 'none')};
  transition: border-color 0.2s ease-in-out;

  &:focus {
    border-color: var(--colorBlueGray1200);
  }
`;
